import {Module} from 'vuex';
import {Page, PageIdentity} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';
import {Api} from 'modules/spravochnik/dt-front-page-generator/src/Api';
import {PageItemInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity';
import {PageItemsFilter} from 'modules/spravochnik/dt-front-page-generator/src/Service/PageService/PageItemsFilter';
import {State} from '../index';
import ChunkCollection from "modules/spravochnik/dt-front-page-generator/src/Utils/ChunkCollection";

interface PageStateInterface {
    page: Page | null,
    pageItemPageNumber: number,
    pageItems: ChunkCollection<PageItemInterface>,
}

const pageModule: Module<PageStateInterface, State> = {
    namespaced: true,
    state: {
        page: null,
        pageItemPageNumber: 1,
        pageItems: new ChunkCollection<PageItemInterface>([]),
    },
    getters: {
        page(state: PageStateInterface): Page {
            return state.page;
        },
        fetchPageItems(state: PageStateInterface): ChunkCollection<PageItemInterface> {
            return state.pageItems;
        },
        pageNumber(state: PageStateInterface): number {
            return state.pageItemPageNumber;
        },
    },
    actions: {
        async loadPageByIdentity({commit, state, rootState}, identity: PageIdentity) {
            for (const category of rootState.category.categories) {
                if (category.name.urlName === identity.categoryUrlName) {
                    const page = category.findPageByIdentity(identity);
                    if (page) {
                        commit('setPageByCache', page);
                        return Promise.resolve();
                    }
                }
            }

            const page = await Api.getPage(identity);
            commit('setPage', page);
        },
        async loadPageItems({commit, state}, page: Page) {
            const pageItems = await Api.fetchPageItems(page.identity, new PageItemsFilter(page.filters), page.sortMode, state.pageItemPageNumber);

            commit('setPageItems', pageItems);
        },
        changePageNumber({commit, state}, pageNumber: number) {
            commit('setPageItemPageNumber', pageNumber);
        },
        resetPageNumber({commit}) {
            commit('setPageItemPageNumber', 1);
        }
    },
    mutations: {
        setPage(state: PageStateInterface, page: Page) {
            state.page = page;
        },
        setPageByCache(state: PageStateInterface, page: Page) {
            state.page = page;
        },
        setPageItems(state: PageStateInterface, pageItems: ChunkCollection<PageItemInterface>) {
            state.pageItems = pageItems;
        },
        setPageItemPageNumber(state: PageStateInterface, pageNumber: number) {
            state.pageItemPageNumber = pageNumber;
        },

    }
};

export {pageModule, PageStateInterface};
